import React, { useState, useContext } from 'react';
import { AppContext } from '../../App';
import Spinner from "../Spinner/Spinner";
import Logo from "../../icons/logo-red.svg";
import './LoginForm.styles.scss';
import Close from "../../icons/close.svg";

function LoginForm() {
    const {
        login,
        isLoginFailedMsgShown,
        setIsLoginFailedMsgShown,
        isLoading,
        setIsLoginModalActive,
    } = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isEmailInvalidMsgShown, setIsEmailInvalidMsgShown] = useState(false);
    const [isPasswordInvalidMsgShown, setIsPasswordInvalidMsgShown] = useState(false);

    const handleEmailChange = ({ target }) => {
        setEmail(target.value);
        setIsEmailInvalidMsgShown(false);
        setIsLoginFailedMsgShown(false);
    };

    const handlePasswordChange = ({ target }) => {
        setPassword(target.value);
        setIsPasswordInvalidMsgShown(false);
        setIsLoginFailedMsgShown(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // const isEmailValid = isEmailCorrect(email);
        const isEmailValid = email.trim().length > 0;
        const isPasswordValid = password.length > 0;

        if (isEmailValid && isPasswordValid) {
            login({
                email,
                password,
            })
        } else {
            if (!isEmailValid) {
                setIsEmailInvalidMsgShown(true);
            }
            if (!isPasswordValid) {
                setIsPasswordInvalidMsgShown(true);
            }
        }
    };

    return (
        <div className="login-modal">
            <div
                className="overlay"
                onClick={() => setIsLoginModalActive(false)}
            />
            <div className={`login-form__loader ${isLoading ? 'login-form__loader--visible' : ''}`}>
                <Spinner/>
            </div>

            <div className="login-form">
                <button
                    className="login-form__close"
                    onClick={() => setIsLoginModalActive(false)}
                >
                    <Close />
                </button>
                <div className="login-form__logo">
                    <Logo />
                </div>
                <div className="subscribers-popup__title">Login</div>
                <div className="subscribers-popup__text">Please login to IFMA to access this feature.</div>
                <form
                    className="form form--error"
                    onSubmit={handleSubmit}
                >
                    <div className="form__input-container">
                        {isEmailInvalidMsgShown && (
                            <span className="form__error form__error--empty">
                                Please enter user name
                            </span>
                        )}
                        <input
                            type="text"
                            className={`form__input form__input--${email.length > 0 ? 'filled' : 'empty'}`}
                            value={email}
                            onChange={handleEmailChange}
                        />
                        <span className="form__label">
                            User name:
                        </span>
                    </div>
                    <div className="form__input-container">
                        {isPasswordInvalidMsgShown && (
                            <span className="form__error form__error--empty">
                                Please enter password
                            </span>
                        )}
                        <input
                            type="password"
                            className={`form__input form__input--${password.length > 0 ? 'filled' : 'empty'}`}
                            value={password}
                            onChange={handlePasswordChange}
                        />
                        <span className="form__label">
                            Password:
                        </span>
                    </div>
                    {isLoginFailedMsgShown && (
                        <span className="form__error form__error--invalid">
                            Invalid credentials, please verify them and retry
                        </span>
                    )}
                    <button className="form__btn btn btn--login btn--wide">
                        Log in
                    </button>
                    <div className="form__footer">
                        Forgot your password or need to create<br/> an IFMA account?<br/>
                        <a
                            rel="noopener noreferrer"
                            href="https://member.ifmaworld.com/IfmaMbr/Contact_Management/Sign_In.aspx?returnurl=%2Fifmambr%2Fspringboard%2Fwww.aspx"
                            className="form__link"
                            target="_blank"
                        >
                            Click here.
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginForm;